<script>
    export let show = false;
    export let color = '#595866';
    export let width = 32;
    export let height = 32;

    export let rotate = true;
</script>

{#if show}
    <svg class={`loader ${rotate ? 'rotating' : ''}`} width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.6665 16.0001C2.6665 23.3641 8.63584 29.3334 15.9998 29.3334C23.3638 29.3334 29.3332 23.3641 29.3332 16.0001C29.3332 8.63608 23.3638 2.66675 15.9998 2.66675"
              stroke={color}
              stroke-width="2.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
        ></path>
    </svg>
{/if}

<style>
    .loader {
        margin-right: 5px;
        margin-left: 5px;
    }
    @-moz-keyframes spin {
        100% { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform:rotate(360deg);
        }
    }

    .rotating {
        -webkit-animation:spin 4s linear infinite;
        -moz-animation:spin 4s linear infinite;
        animation:spin 4s linear infinite;
    }
</style>